<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">
                <div class="row justify-content-center">
                    <div>
                        <p class="h2 page-title">Find a Doctor</p>
                    </div>
                </div>
                
                <div class="row justify-content-center phil-row-info doctor-row">
                    <div class="col-4">
                        <p><strong>Doctor Name:</strong></p>
                      </div>
                      <div class="col-8">
                        <form autocomplete="off" class="form-inline doctor-name-form" @submit.prevent="handleSearch" >
                  <input ref="firstInput" v-model="FirstName" class="form-control mr-sm-2" type="search" placeholder="First Name" aria-label="Search" @focus="show" data-layout="normal">
                  <input  v-model="LastName" class="form-control mr-sm-2" type="search" placeholder="Last Name" aria-label="Search" @focus="show" data-layout="normal">
                  <button class="btn btn-outline-success my-2 my-sm-0 phil-specialization-button" type="submit">Search</button>
                </form>
                      </div>
                      <div class="col-md-12">
                    <div class="list-group scroll">
                      <a v-if="Doctors.length == 0" style="font-size:30px;">Please Enter a Doctor Name.</a>
                        <a v-else-if="Doctors.length != 0" href="#" class="list-group-item list-group-item-action" v-for="item in Doctors" :key="item.DoctorCode" >
                        {{item.DoctorName}}<br>
                        {{item.Specialization}}<br>
                        {{item.TelNo}}
                      </a>
                    </div>
                
                  </div>
                </div>

            
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <router-link to="/find-a-doctor"><button class="btn btn-primary btn-lg" style="margin-top: 25px;">BACK</button></router-link>
                </div>
            </div>
        </div>
        </section>
        <div class='spinner load' v-if='loading'><img src="../assets/phil-care-loading-logo.gif"/></div>
  
</body>
</template>

<script>
import axios from 'axios';
export default {
  name: 'DoctorName',
  data() {
    return {
      certNo: '',
      TokenID: '',
      LastName: '',
      FirstName: '',
      Doctors: [],
      error: false,
      loading: false,
      visible: false,
        layout: "normal",
        input: null,
        options: {
        useKbEvents: false,
        preventClickEvent: false
    }


    }
  },
  methods: {
    async handleSearch() {
      this.loading = true
      this.TokenID = localStorage.getItem('TokenID')
      this.certNo = localStorage.getItem('CertNo')
        const response = await axios.post('/api/?action=member-doctor-name', {
           FirstName: this.FirstName,
           TokenID: this.TokenID,
           LastName: this.LastName,
           ProviderCode: localStorage.getItem('setProvider'),
           CertNo: this.certNo
        }, 
        );

        console.log(response.data['httpCode']);
        //if (response.data[0]==)
        this.Doctors=response.data
        console.log(this.Doctors);
        this.loading = false
        
        
    },
    accept() {
          this.hide();
        },
 
        show(e) {
          this.input = e.target;
          this.layout = e.target.dataset.layout;
 
          if (!this.visible)
            this.visible = true
        },
 
        hide() {
          this.visible = false;
          console.log(document.querySelector(":focus"));
        }
    
  },
  created() {
    if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
  },
  mounted() {
    this.$refs.firstInput.focus();
  }

  }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
